import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <span className="eyebrow">&copy; {new Date().getFullYear()} EditImagePro</span>
    <span className="footer-links">
      <a
        className="eyebrow footer-link"
        href="https://buymeacoffee.com/siri"
        target="_blank"
        rel="noopener noreferrer"
      >
        Buy the creator a coffee
      </a>
      <Link className="eyebrow footer-link" to="/privacy-policy">
        Privacy Policy
      </Link>
    </span>
  </footer>
);

export default Footer;
